import { render, staticRenderFns } from "./name-pattern.vue?vue&type=template&id=06949d9e&"
import script from "./name-pattern.vue?vue&type=script&lang=js&"
export * from "./name-pattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports